export const COMIC_SERIAL_ONGOING = 1
export const COMIC_SERIAL_ENDED = 2
export const COMIC_CHAPTER_STATE_OFF = 1
export const COMIC_CHAPTER_STATE_ON = 2
export const COMIC_CHAPTER_STATE_REMOVED = 3
